import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const getCompanies = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company`, data);
        return await response.data;
    } catch (error) {
        console.log("getCompanies - error", error)
        return handleApiError(error)
    }
}

export const searchCompanies = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company/search`, data);
        return await response.data;
    } catch (error) {
        console.log("searchCompanies - error", error)
        return handleApiError(error)
    }
}

export const getCompanyById = async (companyId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/company/${companyId}`);
        return await response.data;
    } catch (error) {
        console.log("getCompanyById - error", error)
        return handleApiError(error)
    }
}

export const insertCompany = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company/insert`, data);
        return await response.data;
    } catch (error) {
        console.log("insertCompany - error", error)
        return handleApiError(error)
    }
}

export const updateCompanyDetails = async (data, companyId) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company/update/${companyId}`, data);
        return await response.data;
    } catch (error) {
        console.log("updateCompanyDetails - error", error)
        return handleApiError(error)
    }
}

export const updateCompanyStatus = async (statusId, companyId) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company/updateStatus/${companyId}`, statusId);
        return await response.data;
    } catch (error) {
        console.log("updateCompanyStatus - error", error)
        return handleApiError(error)
    }
}


export const getCompanyWithGSTIN = async (companyId) => {
    const data = {
        companyId: companyId
    }
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company/getCompanyWithGSTIN`, data);
        return await response.data;
    } catch (error) {
        console.log("getCompanyWithGSTIN - error", error)
        return handleApiError(error)
    }
}

export const getInitialData = async () => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/company/getInitialData`);
        return await response.data;
    } catch (error) {
        console.log("getInitialData - error", error)
        return handleApiError(error)
    }
}

export const getCompanyRoles = async (companyId, companyRoleIds) => {
    const req_params = {
        companyId : companyId
    }
    if(companyRoleIds){
        req_params.companyRoleIds = companyRoleIds
    }
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company/getCompanyRoles`, req_params);
        return await response.data;
    } catch (error) {
        console.log("getCompanyRoles - error", error)
        return handleApiError(error)
    }
}

export const uploadFile = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/uploadFile`, data);
        return await response.data;
    } catch (error) {
        return handleApiError(error)
    }
}

export const getGstinDetailsFromApiTaxProGsp = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/getGstinDetailsFromApiTaxProGsp`, data);
        return await response.data;
    } catch (error) {
        return handleApiError(error)
    }
}

export const insertBulkUsers = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company/insertBulkUsers`, data);
        return await response.data;
    } catch (error) {
        return handleApiError(error)
    }
}

export const verifyGSTINsByPanNumber = async (panNumber) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/company/verify-gstin/${panNumber}`);
        return await response.data;
    } catch (error) {
        console.log("verifyGSTINsByPanNumber - error", error)
        return handleApiError(error)
    }
}

export const getRCCompanies = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company/companies/RC`, data);
        return response;
    } catch (error) {
        console.log("getRCCompanies - error", error)
        return handleApiError(error)
    }
}

export const getADHOCCompanies = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company/companies/ADHOC`, data);
        return response;
    } catch (error) {
        console.log("getRCCompanies - error", error)
        return handleApiError(error)
    }
}

export const getSTOCKCompanyBranches = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company/companies/STOCK`, data);
        return response;
    } catch (error) {
        console.log("getSTOCKCompanyBranches - error", error)
        return handleApiError(error)
    }
}

export const getBuyerCompanies = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company/buyer-companies`, data);
        return await response.data;
    } catch (error) {
        console.log("getBuyerCompanies - error", error)
        return handleApiError(error)
    }
}

export const getCompanyListByCompanyId = async (companyId) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company/companies/byCompanyId/${companyId}`);
        return await response.data;
    } catch (error) {
        console.log("getCompanyListByCompanyId - error", error)
        return handleApiError(error)
    }
}

export const updateCompanyPrimaryGSTIN = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company/update-gstinCode`, data)
        return await response.data;
    } catch (error) {
        console.log("updateCompanyPrimaryGSTIN - error", error)
        return handleApiError(error)
    }
}